import React from "react";
import logger from "logger";
import AngSelect from "Common/Angular/AngSelect";

const getCityNameForHero = (AccountDetailData, selectedhero) => {
  let retObj = null;
  if (selectedhero && selectedhero.heroname) {
    AccountDetailData.heroes.forEach((city) => {
      city.cityheroes.map((hero) => {
        const { heroname } = hero;
        if (heroname === selectedhero.heroname) {
          retObj = city.cityname;
        }
      });
    });
  }
  return retObj;
};

export default (props) => {
  const { label, AccountDetailData, taskConfig, setValue, param } = props;
  const paramValue = taskConfig[param];
  const [selectedcity, setSelectedcity] = React.useState(
    getCityNameForHero(AccountDetailData, paramValue)
  );
  let selectedCityDetail = null;
  AccountDetailData.heroes.forEach((city) => {
    if (city.cityname === selectedcity) {
      selectedCityDetail = city;
    }
  });
  const options = AccountDetailData.heroes.map((city) => {
    logger.log(city);
    const { cityname } = city;
    return { label: cityname, value: cityname };
  });

  const herooptions =
    (selectedCityDetail &&
      selectedCityDetail.cityheroes.map((hero) => {
        logger.log(hero);
        const { heroname } = hero;
        return { label: heroname, value: hero };
      })) ||
    [];

  logger.log("paramValue", paramValue);

  return (
    <>
      <div style={{ marginTop: "5px" }}>
        <span style={{ float: "left", marginBottom: "10px" }}>{label}</span>
      </div>
      <div>
        <AngSelect
          placeholder="Select a city"
          ng-model={selectedcity}
          options={options}
          onChange={(event) => {
            logger.log("event", event);
            const value = event.value;
            setSelectedcity(value);
          }}
        />
      </div>
      <div style={{ paddingTop: "5px" }}>
        <AngSelect
          placeholder="Select a hero"
          required={true}
          ng-model={paramValue}
          disabled={!selectedcity}
          options={herooptions}
          onChange={({ value }) => {
            var selhero = null;
            selectedCityDetail &&
              selectedCityDetail.cityheroes.forEach((hero) => {
                if (hero.heroname === value.heroname) {
                  selhero = hero;
                }
              });
            logger.log("selhero", selhero);
            if (selhero && selhero.heroname) {
              setValue({ target: { value: selhero } }, param);
            }
          }}
        />
      </div>
    </>
  );
};
